import { render } from "./PasswordExpiredView.vue?vue&type=template&id=20a4c417"
import script from "./PasswordExpiredView.vue?vue&type=script&lang=js"
export * from "./PasswordExpiredView.vue?vue&type=script&lang=js"

import exportComponent from "/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__